import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export type Database = {
  public: {
    Tables: {
      users: {
        Row: {
          id: string
          email: string
          first_name: string | null
          last_name: string | null
          role: 'client' | 'coach'
          phone: string | null
          avatar_url: string | null
          created_at: string
          updated_at: string
        }
        Insert: {
          id: string
          email: string
          first_name?: string | null
          last_name?: string | null
          role?: 'client' | 'coach'
          phone?: string | null
          avatar_url?: string | null
        }
        Update: {
          email?: string
          first_name?: string | null
          last_name?: string | null
          role?: 'client' | 'coach'
          phone?: string | null
          avatar_url?: string | null
        }
      }
      coaches: {
        Row: {
          id: string
          user_id: string
          specialty: string
          experience_years: number | null
          hourly_rate: number | null
          location: string | null
          description: string | null
          languages: string[] | null
          certifications: string[] | null
          availability: any | null
          rating: number
          total_reviews: number
          is_verified: boolean
          created_at: string
          updated_at: string
        }
        Insert: {
          user_id: string
          specialty: string
          experience_years?: number | null
          hourly_rate?: number | null
          location?: string | null
          description?: string | null
          languages?: string[] | null
          certifications?: string[] | null
          availability?: any | null
          is_verified?: boolean
        }
        Update: {
          specialty?: string
          experience_years?: number | null
          hourly_rate?: number | null
          location?: string | null
          description?: string | null
          languages?: string[] | null
          certifications?: string[] | null
          availability?: any | null
          is_verified?: boolean
        }
      }
      bookings: {
        Row: {
          id: string
          client_id: string
          coach_id: string
          session_date: string
          duration: number
          total_price: number | null
          status: 'pending' | 'confirmed' | 'completed' | 'cancelled'
          payment_status: 'pending' | 'paid' | 'refunded'
          stripe_payment_intent_id: string | null
          notes: string | null
          created_at: string
          updated_at: string
        }
        Insert: {
          client_id: string
          coach_id: string
          session_date: string
          duration?: number
          total_price?: number | null
          status?: 'pending' | 'confirmed' | 'completed' | 'cancelled'
          payment_status?: 'pending' | 'paid' | 'refunded'
          stripe_payment_intent_id?: string | null
          notes?: string | null
        }
        Update: {
          session_date?: string
          duration?: number
          total_price?: number | null
          status?: 'pending' | 'confirmed' | 'completed' | 'cancelled'
          payment_status?: 'pending' | 'paid' | 'refunded'
          stripe_payment_intent_id?: string | null
          notes?: string | null
        }
      }
      reviews: {
        Row: {
          id: string
          booking_id: string
          client_id: string
          coach_id: string
          rating: number
          comment: string | null
          created_at: string
        }
        Insert: {
          booking_id: string
          client_id: string
          coach_id: string
          rating: number
          comment?: string | null
        }
        Update: {
          rating?: number
          comment?: string | null
        }
      }
    }
  }
}